import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, useEffect } from "react";
const DesktopSkeletonPage = lazy(() => import('./view/desktop/desktopSkeletonPage'));
const MobileSkeletonPage = lazy(() => import('./view/mobile/mobileSkeletonPage'));
export const SkeletonPage = (props) => {
    useEffect(() => {
        if (props.isMobile) {
            require('./view/mobile/style.css');
        }
        else {
            require('./view/desktop/style.css');
        }
    }, []);
    if (props.isMobile) {
        return _jsx(MobileSkeletonPage, {});
    }
    return _jsx(DesktopSkeletonPage, {});
};
